import styled from "@emotion/styled";
import React from "react";
import {
  CommCenterMessageActionId,
  CommCenterMessagePayloadActionList,
  CommCenterTicketId,
} from "../../../messages";
import { CommCenterListActionItem } from "../utils/chatUtils";

interface Props {
  ticketId: CommCenterTicketId;
  actionId: CommCenterMessageActionId;
  list: CommCenterMessagePayloadActionList;
  isLatestMessage: boolean;
  onClickActionItem: (item: CommCenterListActionItem, actionId: CommCenterMessageActionId) => void;
}

function ChatMessageList(props: Props) {
  const handleClick = (item: CommCenterListActionItem) => {
    if (!props.isLatestMessage) {
      return;
    }

    props.onClickActionItem(item, props.actionId);
  };

  return (
    <ChatMessageList.Root>
      {props.list.items.map((item) => (
        <ChatMessageList.Item key={item.id} onClick={() => handleClick(item)}>
          {item.icon !== undefined ? <img src={item.icon} /> : null}
          <span>{item.text}</span>
        </ChatMessageList.Item>
      ))}
    </ChatMessageList.Root>
  );
}

ChatMessageList.Root = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

ChatMessageList.Item = styled.li`
  background: white;
  color: #3077eb;
  font-weight: 700;
  font-size: 14px;
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 12px;
  border-radius: 16px;
  cursor: pointer;
`;

export default ChatMessageList;
